<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><span><a id="page_ix"></a>To my family</span></p>
<p class="dedication1"><span>(Julie; the deaconess; the two spies;<br/>
  and the beloved physician)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f9c11316